export interface StatItem {
  icon: string;
  number: number;
  label: string;
}

export const statsData: StatItem[] = [
  { icon: "fa-bullhorn", number: 1458, label: "Projects" },
  { icon: "fa-file-text", number: 21, label: "Profiles" },
  { icon: "fa-briefcase", number: 3573, label: "Employers" },
  { icon: "fa-user", number: 3895, label: "Users" },
];